import { observable, makeObservable } from 'mobx';
import { createModelSchema, primitive, object } from 'serializr';

import uuid from 'uuid/v4';

class Metadata {
    title = '';
    description = '';
    callToAction = '';
    link = '';
    verificationUrl = '';

    constructor() {
        makeObservable(this, {
            title: observable,
            description: observable,
            callToAction: observable,
            link: observable,
            verificationUrl: observable
        });
    }
}
createModelSchema(Metadata, {
    title: primitive(),
    description: primitive(),
    callToAction: primitive(),
    link: primitive(),
    verificationUrl: primitive()
});

class Settings {
    popup = false;
    when = 'dispatched';

    constructor() {
        makeObservable(this, {
            popup: observable,
            when: observable
        });
    }
}

createModelSchema(Settings, {
    popup: primitive(),
    when: primitive()
});

export type WidgetType = 'image' | 'promotion' | 'video' | 'text' | 'opt_in' | 'rating' | 'address_correction' | 'tip'

/** site / job campaign widget */
export class Widget {

    id: string;
    type: WidgetType = 'promotion';
    content = ""
    metadata: Metadata;
    settings: Settings;

    constructor() {
        makeObservable(this, {
            type: observable,
            content: observable,
            metadata: observable,
            settings: observable
        });

        this.id = uuid();
        this.metadata = new Metadata();
        this.settings = new Settings();
    }
}

createModelSchema(Widget, {
    id: primitive(),
    type: primitive(),
    content: primitive(),
    metadata: object(Metadata),
    settings: object(Settings)
});
